import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios'
import VueAxios from 'vue-axios'
import AppModule from './AppModule.vue';
import Notifications from 'vue-notification'
import Vodal from 'vodal';
import titleMixin from './utils/TitleUtil.js'
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import VueScrollTo from 'vue-scrollto';
import VueQriously from 'vue-qriously';
import { VueReCaptcha } from 'vue-recaptcha-v3';

import routes from './routes.js';
import { i18n } from './translation.js';
import AuthUtil from './utils/AuthUtil';
import UserService from './services/UserService'

import config from '../config.js';

import roundFilter from './filters/round';
import floorFilter from './filters/floor';
import roundupFilter from './filters/roundup';

moment.tz.setDefault('Asia/Singapore');

Vue.use(Notifications);
Vue.use(VueAxios, axios);
Vue.use(VueRouter);
Vue.use(VueMoment, { moment });
// recaptchaサイトキー読み込み
if (!!config.recaptchaClientKey) {
    Vue.use(VueReCaptcha, {
        siteKey: config.recaptchaClientKey
    });
}

// header分調整
const headerHeight = window.parent.screen.width > 991 ? -78 : -65;
Vue.use(VueScrollTo, {offset: headerHeight});
Vue.use(VueQriously);

Vue.config.productionTip = false;

Vue.component('app-module', AppModule.default);
Vue.component(Vodal.name, Vodal);
Vue.mixin(titleMixin);

roundFilter.apply(Vue);
floorFilter.apply(Vue);
roundupFilter.apply(Vue);

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach(async (to, from, next) => {
    if ((to.meta !== undefined) && (to.meta !== null)) {
        // リファラ取得
        router['referrer'] = from;
    
        // グローバル認証ガード
        const requiresAuth    = to.meta['requiresAuth'];
        const isAuthenticated = AuthUtil.isAuth();

        // 認証が不要の場合はスキップ
        if (requiresAuth === false) {
            return next();
        }

        // ログイン必須ページの場合はログイン画面へ
        if ((requiresAuth === true) && (isAuthenticated !== true)) {
            return next({ path: '/login' });
        }

        // グローバルメンバーシップガード
        if (isAuthenticated === true) {
            // 会員資格停止フラグの取得
            const isSuspended = (await UserService.isSuspended()).data.is_suspended;
            // 会員資格が停止中の場合には強制的にログアウト画面へと遷移させる
            if (isSuspended) {
                AuthUtil.clearAuth();
                return next({ path: '/logout' });
            }

            const membershipTypes = to.meta['authorizedMembershipTypes'];

            if (Array.isArray(membershipTypes)) {
                const userData = (await UserService.getUserFrontendData()).data;

                if (typeof userData === 'object') {
                    // MEMO: `users`.`member_type_id` は ''数値''
                    const membershipType = userData['member_type_id'];

                    if (typeof membershipType === 'number') {
                        if (membershipTypes.indexOf(membershipType) < 0) {
                            // メンバーシップガードによりはじかれた場合はトップページに遷移させる
                            return next({ path: '/' });
                        }
                    }
                }
            }
        }
    }

    return next();
});

router.afterEach((to, from) => {
    if ('gtag' in window) {
        gtag('config', 'UA-154501723-1', {'page_path': to.path});
    }
})

const app = new Vue({
    router,
    i18n,
    render (h) {
        return h(AppModule)
    }
}).$mount('#app');
